export default "__VITE_ASSET__CnFsTnXY__"